// Responsive want ad card - replaces PropertyListing.js
// Mobile: vertical layout (title/location above full-width map, info below).
// Desktop: horizontal layout (233px map left, info right) matching existing design.
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PreApprovedLogo from "src/images/v2/PreApprovedIcon.svg";
import DisplacedFired from "src/images/v2/displaced-fire.svg";
import HearttIcon from "src/images/heart-icon.svg";
import HearttIconFilled from "src/images/heart-icon-filled.svg";
import ShareIcon from "src/images/share-icon.svg";
import LakeViewIcon from "src/images/lake-view-icon.svg";
import DefaultProfile from "src/images/v2/Profiles.svg";
import {
  loggedInUser,
  getLocalStorage,
  formateDate,
  durationForFlexibleDate,
  monthNameForFlexibleDate,
  getUserId,
  removeDecimalZeros,
  getUserType,
  locationDisplay,
} from "@/helpers/common";
import { useSearchParams } from "react-router-dom";
import {
  ADTYPE_LTR,
  ADTYPE_STR,
  IN_CITY_LIMITS,
  RURAL,
  BUY,
  USER_INFO_KEY,
  LOT_LAND,
  BUDGET_NOMIN_NOMAX,
  USER_TYPE_AGENT,
} from "@/constants/common";
import AddToClientWantAdModal from "@/components/MemberWantAd/AddToClientWantAdModal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { setLotSizeValue, wantAdBudgetValue } from "@/helpers/createWantAd";
import { getWantAdById } from "@/services/wantAdService";
import {
  getPropertyIcon,
  getCombinedText,
} from "@/helpers/getPropertyIcons";
import ShareYourAdModal from "@/components/MemberWantAd/v2/ShareYourAdModal";
import { useSelector } from "react-redux";
import PremiumPlanModal from "@/components/PlanUpgrade/PremiumPlanModal";
import BasicPlanModal from "@/components/PlanUpgrade/BasicPlanModal";
import StaticMapboxComponent from "@/components/Common/StaticMapboxComponent";
import { usePolygons } from "@/hooks";
import { useAppConfig } from "@/appConfig";
import { wantAdSqftValue } from "@/helpers";
import useBreakpoint from "@/hooks/useBreakpoint";
import useChipVisibleCount from "@/hooks/useChipVisibleCount";
import MatchReasonsPopover from "@/components/MatchReasonsPopover";
import "./WantAdCard.scss";

const SLIDER_SETTINGS = {
  className: "slider variable-width",
  dots: false,
  infinite: false,
  centerMode: false,
  slidesToShow: 1,
  swipeToSlide: true,
  variableWidth: true,
  arrows: false,
};

const WantAdCard = ({
  handleFavoriteOrUnfavoriteWantAd,
  onChangeText,
  onAddClient,
  handleWantAdItemClick,
  ...props
}) => {
  const [verifyUser] = useSearchParams();
  const isUserVerified = verifyUser.get("verify");
  const [isFavourite, setIsFavourite] = useState(0);
  const [wantAdId, setWantAdId] = useState(0);
  const [showPremiumPlanModal, setPremiumPlanModal] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [showShareModal, setShareModal] = useState(false);
  const [selectedWantAd, setSelectedWantAd] = useState({});
  const [isPremiumUser, setIsPremiumUser] = useState(null);
  const [userDetails, setUserDetails] = useState(null);

  const user = loggedInUser();
  const sessionData = getLocalStorage(USER_INFO_KEY);
  const loggedInUserId = getUserId();
  const userType = getUserType();
  const { flags, tenant } = useAppConfig();
  const isDemoTenant = tenant?.demoMode === true;
  const blsId = isDemoTenant ? 100000 + (Want_ad_Id % 99999) : null;
  const { isPhone } = useBreakpoint();
  const maxVisibleN2H = useChipVisibleCount();

  const userDetailsFromStore = useSelector(
    (state) => state.userProfile.userDetails,
  );

  const {
    Title_Text,
    Bedrooms,
    Bathrooms,
    Budget_mn,
    Budget_mx,
    Sqft_mn,
    Sqft_mx,
    N2H,
    isLotLand,
    LotType_Rural_City,
    LotSz_mn,
    LotSz_mx,
    AdType,
    Want_ad_Id,
    IsFavourite,
    subPropertyTypeId,
    Date_From,
    Date_To,
    DateType,
    Duration,
    Month,
    Longitude,
    Latitude,
    mapRadius,
    CreatedBy,
    financeTypeText,
    isApprovedForLoan,
    userFirstName,
    userLastName,
    userAvatar,
    userCompany,
    userUserTypeId,
    fireDisplaced,
    Is_Agent_Created,
    slug,
    zipCode,
    syndicationPrivacy: syndicationPrivacyProp,
    syndicationFeed: syndicationFeedProp,
    score,
    reasons,
  } = props && props.list;

  const { polygonCoordinates, isLoading: isPolygonLoading } = usePolygons(zipCode, false);
  const syndicationPrivacy = syndicationPrivacyProp ?? "show";
  const syndicationFeed = syndicationFeedProp ?? "public";

  // Budget display
  let budget = wantAdBudgetValue(Budget_mn, Budget_mx);
  if (budget !== BUDGET_NOMIN_NOMAX) {
    if (AdType === ADTYPE_LTR) budget = budget + " /Month";
    else if (AdType === ADTYPE_STR) budget = budget + " /Night";
  }

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      if (
        (userDetailsFromStore[0]?.period !== 1 && userType === 2) ||
        userType === 3
      ) {
        setIsPremiumUser(true);
      } else {
        setIsPremiumUser(false);
      }
    }
  }, [userDetailsFromStore]);

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      setUserDetails(userDetailsFromStore[0]);
    } else {
      setUserDetails(null);
    }
  }, [userDetailsFromStore]);

  // --- Handlers ---

  const handleAgentsFavoriteAction = (isFav, wId) => {
    setIsFavourite(isFav);
    setWantAdId(wId);
    setModalShow(true);
  };

  const handleClientFavoriteWantAd = (agentIds) => {
    handleFavoriteOrUnfavoriteWantAd(isFavourite, wantAdId, agentIds);
  };

  const handleShare = (e, shareSlug) => {
    e.stopPropagation();
    if (shareSlug) {
      getWantAdById(shareSlug)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            setSelectedWantAd(responseResult);
            setShareModal(true);
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  // --- Sub-renders ---

  const renderTooltip = (tooltipProps) => (
    <Tooltip
      id="button-tooltip"
      placement="bottom-start"
      className="custom-tooltip"
      {...tooltipProps}
    >
      {subPropertyTypeId?.length > 0 && getCombinedText(subPropertyTypeId)}
    </Tooltip>
  );

  const PropertyTypeBadge = () => (
    <div className={`wac__badge ${fireDisplaced ? "wac__badge--fire" : ""}`}>
      <OverlayTrigger
        placement="bottom-start"
        delay={{ show: 250, hide: 400 }}
        overlay={renderTooltip}
      >
        {(() => {
          const uniqueSubtypes = Array.isArray(subPropertyTypeId)
            ? Array.from(new Set(subPropertyTypeId))
            : [];
          return (
            <div className="wac__badge-icons">
              {uniqueSubtypes.length > 0 &&
                uniqueSubtypes.slice(0, 3).map((subtype, i) => (
                  <img
                    key={i}
                    src={getPropertyIcon(subtype)}
                    alt=""
                    className="wac__badge-icon"
                  />
                ))}
              {uniqueSubtypes.length > 3 && (
                <span> +{uniqueSubtypes.length - 3}</span>
              )}
            </div>
          );
        })()}
      </OverlayTrigger>
    </div>
  );

  const MustHaves = () => {
    if (isLotLand) {
      return (
        <div className="wac__details">
          {LotType_Rural_City && (
            <>
              {LotType_Rural_City === 1 ? RURAL : IN_CITY_LIMITS}{" "}
              <span className="wac__details-label">lot type</span>
              <span className="wac__divider">|</span>
            </>
          )}
          {setLotSizeValue(
            removeDecimalZeros(LotSz_mn),
            removeDecimalZeros(LotSz_mx),
          )}{" "}
          {setLotSizeValue(
            removeDecimalZeros(LotSz_mn),
            removeDecimalZeros(LotSz_mx),
          ) === "Any" && <span className="wac__details-label">lot size</span>}
        </div>
      );
    }

    let bedRm = "Any";
    let bathRm = "Any";
    const sqFt = wantAdSqftValue(Sqft_mn, Sqft_mx);

    if (Bedrooms && Bedrooms !== 99) bedRm = `${Bedrooms}+`;
    if (Bathrooms && Bathrooms !== 99) bathRm = `${Bathrooms}+`;

    let timeLine;
    if (AdType === ADTYPE_STR) {
      if (DateType === 1 || DateType == null) {
        timeLine =
          formateDate(Date_From, "mm/dd/yyyy") +
          " - " +
          formateDate(Date_To, "mm/dd/yyyy");
      } else if (DateType === 2) {
        timeLine =
          durationForFlexibleDate(Duration) +
          " - " +
          monthNameForFlexibleDate(Month);
      }
    }

    return (
      <div className="wac__details">
        {bedRm} <span className="wac__details-label">beds</span>
        <span className="wac__divider">|</span>
        {bathRm} <span className="wac__details-label">baths</span>
        {sqFt && AdType !== ADTYPE_STR && (
          <>
            <span className="wac__divider">|</span>
            <span>{sqFt}</span>{" "}
            <span className="wac__details-label">sqft</span>
          </>
        )}
        {timeLine && AdType === ADTYPE_STR && (
          <span className="wac__details-label">{timeLine}</span>
        )}
      </div>
    );
  };

  const NiceToHaveSlider = () => {
    if (!N2H?.length) return null;
    const cardCap = Math.max(2, Math.min(maxVisibleN2H - 1, 4));
    const visible = N2H.slice(0, cardCap);
    const overflow = N2H.length - cardCap;
    return (
      <div
        className="wac__tags wac__tags--row"
        onClick={(e) => e.stopPropagation()}
      >
        {visible.map((nh, index) => {
          const itemText = _.get(nh, "Text", "");
          const icon = _.get(nh, "Icon", "");
          return (
            <div className="wac__tag" key={index + "_" + _.get(nh, "Want_ad_Id", "")}>
              <div className="wac__tag-icon">
                <img
                  src={icon ? require("../../../images/" + icon) : LakeViewIcon}
                  alt=""
                />
              </div>
              <span>{itemText}</span>
            </div>
          );
        })}
        {overflow > 0 && (
          <div className="wac__tag wac__tag--overflow" key="n2h-overflow">
            <span>+{overflow}</span>
          </div>
        )}
      </div>
    );
  };

  const FinanceTypeBanner = () => {
    const showIcon =
      financeTypeText === "Cash" ||
      (financeTypeText && financeTypeText !== "Other" && isApprovedForLoan);
    const displayText =
      financeTypeText === "Conventional Mortgage" && isApprovedForLoan
        ? "Pre Approved Buyer"
        : financeTypeText !== "Other"
          ? `${financeTypeText} Buyer`
          : "";
    if (!financeTypeText) return null;
    return (
      <div className="wac__finance">
        {showIcon && <img src={PreApprovedLogo} alt="" className="wac__finance-icon" />}
        {displayText}
      </div>
    );
  };

  const AgentInfo = () => {
    if (!Is_Agent_Created) {
      return (
        <div className="wac__agent">
          <div className="wac__agent-avatar">
            <img src={DefaultProfile} alt="avatar" width="32" height="32" />
          </div>
          <span className="wac__agent-label">
            {AdType === 1 ? "Buyer" : "Renter"}
          </span>
        </div>
      );
    }

    return (
      <div className="wac__agent">
        <div className="wac__agent-avatar">
          <img
            src={userAvatar || DefaultProfile}
            alt="avatar"
            width="32"
            height="32"
          />
        </div>
        <div className="wac__agent-info">
          <div className="wac__agent-name">
            {userFirstName} {userLastName}
            {flags.proBadge && <span className="wac__pro-tag">PRO</span>}
          </div>
          <div className="wac__agent-company">{isDemoTenant ? `${tenant?.head?.title?.replace(" - Buyer Listing Service", "") || "MLS"} #BLS${blsId}` : `Agent @ ${userCompany}`}</div>
        </div>
      </div>
    );
  };

  const SocialButtons = () => {
    if (isPhone) return null;
    return (
      <div
        className="wac__social"
        onClick={(e) => e.stopPropagation()}
      >
        {user && (
          <a
            role="button"
            className="wac__social-btn"
            href={void 0}
            onClick={(e) => handleShare(e, slug)}
          >
            <img src={ShareIcon} alt="Share" />
          </a>
        )}
        {(user || isUserVerified) && CreatedBy !== loggedInUserId && (
          IsFavourite ? (
            <a
              role="button"
              href={void 0}
              onClick={() => handleFavoriteOrUnfavoriteWantAd(true, Want_ad_Id)}
              className="wac__social-btn"
            >
              <img src={HearttIconFilled} alt="Unfavorite" />
            </a>
          ) : (
            <a
              role="button"
              href={void 0}
              onClick={() => {
                sessionData?.userInfo?.userType == 2 && isPremiumUser
                  ? handleAgentsFavoriteAction(false, Want_ad_Id)
                  : handleFavoriteOrUnfavoriteWantAd(false, Want_ad_Id);
              }}
              className="wac__social-btn"
            >
              <img src={HearttIcon} alt="Favorite" />
            </a>
          )
        )}
      </div>
    );
  };

  // --- Map dimensions ---
  const mapWidth = isPhone ? 343 : 233;
  const mapHeight = isPhone ? 180 : 179;

  return (
    <>
      <a
        role="button"
        className="wac-link"
        href={void 0}
        onClick={() => handleWantAdItemClick(Want_ad_Id, slug)}
      >
        <div className={`wac ${isPhone ? "wac--vertical" : "wac--horizontal"}`}>
          {/* Mobile: title + location above map */}
          {isPhone && (
            <div className="wac__header">
              <h6 className="wac__title">{Title_Text}</h6>
              <p className="wac__location">{locationDisplay(props.list)}</p>
            </div>
          )}

          {/* Map */}
          <div className="wac__map">
            <PropertyTypeBadge />
            <StaticMapboxComponent
              padding={20}
              width={mapWidth}
              height={mapHeight}
              center={[Longitude, Latitude]}
              radiusMiles={mapRadius}
              polygonCoordinates={polygonCoordinates}
              showPolygon={
                Array.isArray(polygonCoordinates) &&
                polygonCoordinates.length > 0 &&
                Array.isArray(zipCode) &&
                zipCode.length > 0
              }
              isPolygonLoading={isPolygonLoading && Array.isArray(zipCode) && zipCode.length > 0}
            />
          </div>

          {/* Info */}
          <div className="wac__info">
            <div className="wac__top">
              <div className="wac__top-left">
                <div className="wac__price-row">
                  <div className="wac__price">{budget}</div>
                  {fireDisplaced ? (
                    <div className="wac__fire">
                      <img src={DisplacedFired} alt="" width="9" height="11" />
                      DISPLACED BY FIRES
                    </div>
                  ) : (
                    <FinanceTypeBanner />
                  )}
                  {score != null && (
                    <MatchReasonsPopover reasons={reasons} score={score}>
                      <span className="match-score-text">{score}% Match</span>
                    </MatchReasonsPopover>
                  )}
                </div>

                {/* Desktop: title + location inline below price */}
                {!isPhone && (
                  <h6 className="wac__title-desktop">
                    {Title_Text}{" "}
                    <span className="wac__dot">&bull;</span>{" "}
                    <span>{locationDisplay(props.list)}</span>
                  </h6>
                )}

                <MustHaves />
              </div>
              <SocialButtons />
            </div>

            <NiceToHaveSlider />
            <AgentInfo />
          </div>
        </div>
      </a>

      {/* Modals - same as PropertyListing */}
      <AddToClientWantAdModal
        show={modalShow}
        showAddToClientWantAdModal={() => setModalShow(true)}
        onHide={() => setModalShow(false)}
        data={props.results}
        handleSkip={() =>
          handleFavoriteOrUnfavoriteWantAd(isFavourite, wantAdId)
        }
        handleConfirm={handleClientFavoriteWantAd}
        searchText={props.clientSearchText}
        onChangeText={(e) => onChangeText(e)}
        onAddClient={() => onAddClient()}
      />
      {userDetails && userDetails?.userType == 1 ? (
        <PremiumPlanModal
          userDetails={userDetails}
          show={showPremiumPlanModal}
          onHide={() => setPremiumPlanModal(false)}
          showPlanModal={() => setPremiumPlanModal(true)}
        />
      ) : (
        <BasicPlanModal
          userDetails={userDetails}
          show={showPremiumPlanModal}
          onHide={() => setPremiumPlanModal(false)}
          showPlanModal={() => setPremiumPlanModal(true)}
        />
      )}
      {showShareModal && (
        <ShareYourAdModal
          show={showShareModal}
          onHide={() => setShareModal(false)}
          adDetails={selectedWantAd}
          isWantAdCreated={false}
          AdType={_.get(selectedWantAd, "adType", "") === "BUY" ? 1 : 2}
          isAdTypeIsLand={_.get(selectedWantAd, "prprtyType", "") === 6}
          adTypeBasedOnProperty={
            _.get(selectedWantAd, "prprtyType", "") === 6
              ? LOT_LAND
              : _.get(selectedWantAd, "adType", "")
          }
        />
      )}
    </>
  );
};

export default WantAdCard;
